import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {FccDTO, FormSettingsDTO} from '@signature-it/ngx-generic/models';
import {FccConfigType} from '@signature-it/ngx-generic/enums';
import {FormService} from './form.service';
import {ILanguage} from '@signature-it/ngx-generic/interfaces';

declare let _: any;

@Injectable({
    providedIn: 'root'
})
export class FccService {

    protected fcc = new Subject<any>();
    protected loadedFields = new Subject<any>();
    fcc$: any;
    loadedFields$: any;

    constructor(protected formService: FormService) {
        this.fcc$ = this.fcc.asObservable();
        this.loadedFields$ = this.loadedFields.asObservable();
    }


    loadFccValue(formFcc: FccDTO[], lang: ILanguage, flatFormControl, settings: FormSettingsDTO, product: object) {
        const self = this;

        formFcc.forEach(fcc => {
            fcc.resetValue();
            fcc.fccConfig.forEach(fccConfig => {
                switch (fccConfig.type) {
                    case FccConfigType.TEXT:
                        fcc.value = fccConfig.value;
                        break;
                    default:
                    case FccConfigType.STAGE:
                        const fccConf = fccConfig;
                        if(flatFormControl[fccConf.formFieldName].value == '') {
                            fcc.value = `${fccConfig.value}EMPTY`;
                        } else {
                            self.formService.getComponentsFromSolr(lang, fccConfig.componentGroupId, fccConfig.compSolrQuery, settings).subscribe(comp => {
                                const relevantComponent = comp.filter(c => flatFormControl[fccConf.formFieldName].value == c.compCode)[0];
                                if (relevantComponent) {
                                    fcc.value = relevantComponent[fccConfig.sourceFieldName + '_s'] ? fccConfig.value + relevantComponent[fccConfig.sourceFieldName + '_s'] : `${fccConfig.value}EMPTY`;
                                } else {
                                    fcc.value = 'NO-COMPONENT';
                                }
                            });
                        }
                        break;
                    case FccConfigType.CALC:
                        const ans = {};
                        _.map(flatFormControl, (v, k) => ans[k] = v.value);
                        let value = fccConfig.evalCalcFields(ans, product);
                        value = value == undefined ? `${fccConfig.value}EMPTY` : value;
                        fcc.value = fccConfig.value + value;
                        break;
                }
            });
        });
        this.fcc.next(formFcc);
    }

    setAllFields(data) {
        this.loadedFields.next(data);
    }


}
